import {useCallback, useEffect, useRef, useState} from 'react';

const SUCCESS_TOAST_MS = 4000;

const useNotice = () => {
  const [notice, setNotice] = useState(null);
  const counter = useRef(0);
  const clear = useCallback(() => setNotice(null), []);
  const notify = useCallback((message, tone) => {
    counter.current += 1;
    setNotice({message, tone, id: counter.current});
  }, []);

  const id = notice ? notice.id : null;
  const isError = Boolean(notice && notice.tone === 'error');
  useEffect(() => {
    if (id === null || isError) return undefined;
    const timer = setTimeout(clear, SUCCESS_TOAST_MS);
    return () => clearTimeout(timer);
  }, [id, isError, clear]);

  return {notice, notify, clear};
};

export default useNotice;
